import { render, staticRenderFns } from "./AutomaticPaymentsPage.vue?vue&type=template&id=8c4c6b96&"
import script from "./AutomaticPaymentsPage.vue?vue&type=script&lang=js&"
export * from "./AutomaticPaymentsPage.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticPaymentsPage.vue?vue&type=style&index=0&id=8c4c6b96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports